import React from "react"
import { connect } from "react-redux"
import CreatableSelect from "react-select/creatable"
import getOptionsPersons from "../../redux/reselect/getOptionsPersons"
import CustomClearIndicator from "./CustomClearIndicator"
import customStyles from "./style/customStyles"
import { selectPersonsUpdate } from "../../redux/actions/project"

const SelectPersons = ({
  name,
  value,
  optionsPersons,
  isDisabled = false,
  isLocked = false,
  dispatch,
}) => {
  //=================================================================

  //-----------------------------------------------------------------
  const onChange = (data, actionMeta) => {
    // data.label has either the sId or - if new - the new name
    // select Id = sId has nId here

    let payload

    if (actionMeta.action === "clear") {
      payload = { name, selected: [], isNew: false }
    } else {
      payload = { name, selected: data }
    }

    dispatch(selectPersonsUpdate(payload))
  }
  //=================================================================
  return (
    <CreatableSelect
      name={name}
      value={value}
      onChange={onChange}
      options={optionsPersons}
      styles={customStyles}
      isMulti
      isDisabled={isLocked}
      isLocked={isLocked}
      className="basic-multi-select"
      classNamePrefix="select"
      components={{
        ClearIndicator: CustomClearIndicator,
        DropdownIndicator: null,
        IndicatorSeparator: null,
        Placeholder: () => null,
      }}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    optionsPersons: getOptionsPersons(state),
  }
}

export default connect(mapStateToProps)(SelectPersons)
